import axios from "axios";
import React, { useState } from "react";
import Cookies from "js-cookie";
import toast from "react-hot-toast";
import { theme } from "../theme/theme"; // global theme
import { BASE_URL } from '../constants'


const Login = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await axios.post(
        BASE_URL+"/login",
        { email, password },
        { headers: { "Content-Type": "application/json" } }
      );

      const payload = response?.data || {};
      const token =
        payload?.result?.token ||
        payload?.result?.data?.token ||
        payload?.token ||
        payload?.data?.token;
      const userType =
        payload?.result?.user_type ||
        payload?.result?.userType ||
        payload?.user_type ||
        payload?.userType ||
        payload?.data?.user_type;
      const apiMessage =
        payload?.message ||
        payload?.result?.message ||
        payload?.error ||
        (typeof payload?.result === "string" ? payload?.result : "");

      const isHttps = window.location.protocol === "https:";

      if (token) {
        Cookies.set("authToken", token, {
          expires: 30,
          secure: isHttps,
          sameSite: "lax",
        });
        Cookies.set("user_type", userType, {
          expires: 30,
          secure: isHttps,
          sameSite: "lax",
        });

        toast.success(apiMessage || "Login successful");
        onLogin();
        setTimeout(() => {
          window.location.href = "/allbooking";
        }, 500);
      } else {
        setError(apiMessage || "Login failed. User not found.");
      }
    } catch (err) {
      const apiMessage =
        err?.response?.data?.message ||
        err?.response?.data?.result?.message ||
        (typeof err?.response?.data?.result === "string"
          ? err?.response?.data?.result
          : "");
      setError(apiMessage || "Login failed: Please check your credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>
        {`
          html, body, #root {
            margin: 0 !important;
            padding: 0 !important;
            height: 100%;
            width: 100%;
            overflow: hidden;
          }
          .login-container {
            margin: 0 !important;
            padding: 0 !important;
            height: 100vh;
            width: 100vw;
            display: flex;
            flex-direction: row;
          }
          .login-left, {
            height: 100%;
            width: 60%;
            padding: 0;
            margin: 0;
          }
            .login-right {
            height: 100%;
            width: 40%;
            padding: 0;
            margin: 0;
          }
          @media (max-width: 768px) {
            .login-left {
              display: none;
            }
            .login-right {
              width: 100%;
              padding: 1rem;
            }
            .login-card {
              max-width: 90% !important;
              padding: 1.5rem !important;
            }
          }
        `}
      </style>

      <div className="login-container">
        {/* LEFT IMAGE */}
        <div className="login-left">
          <img
            src="/img.jpg"
            alt="sites"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </div>

        {/* RIGHT FORM */}
        <div className="login-right d-flex justify-content-center align-items-center">
          <div
            className="border border-1 login-card"
            style={{
              width: "100%",
              maxWidth: "420px",
              border: "none",
              borderColor: `${theme.colors.secondary}33`,
              borderRadius: theme.borderRadius.large,
              padding: "2.5rem",
              backgroundColor: "#fff",
              fontFamily: theme.font.family,
            }}
          >
            <div className="text-center mb-3">
              <img
                src="/ishan.png"
                alt="logo"
                style={{
                  width: "38%",
                  objectFit: "contain",
                }}
              />
            </div>

            <form onSubmit={handleSubmit} style={{padding:"1rem"}}>
              <h3
                className="text-center fw-bold mb-4 login-heading"
                style={{
                  color: theme.colors.primary,
                  fontSize: "1.4rem",
                  letterSpacing: "0.5px",
                }}
              >
                Login
              </h3>

              {/* Email */}
              <div className="form-group mb-3 text-start">
                <label
                  htmlFor="email"
                  style={{
                    fontSize: "0.9rem",
                    color: theme.colors.text,
                  }}
                >
                  Email
                </label>
                <input
                  type="email"
                  className="form-control mt-2"
                  id="email"
                  placeholder="Enter email"
                  value={email}
                  required
                  onChange={(e) => setEmail(e.target.value)}
                  style={{
                    height: "40px",
                    fontSize: "0.9rem",
                    borderRadius: theme.borderRadius.medium,
                    borderColor: `${theme.colors.secondary}88`,
                  }}
                />
              </div>

              {/* Password */}
                   
              <div className="form-group mb-3 text-start position-relative">
                <label
                  htmlFor="password"
                  style={{
                    fontSize: "0.9rem",
                    color: theme.colors.text,
                  }}
                >
                  Password
                </label>
              
                <div className="position-relative mt-2">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    id="password"
                    placeholder="Enter password"
                    value={password}
                    required
                    onChange={(e) => setPassword(e.target.value)}
                    style={{
                      height: "40px",
                      fontSize: "0.9rem",
                      borderRadius: theme.borderRadius.medium,
                      borderColor: `${theme.colors.secondary}88`,
                      paddingRight: "2.2rem", // add space for the icon
                    }}
                  />
              
                  <span
                    className="position-absolute"
                    onClick={togglePasswordVisibility}
                    style={{
                      top: "50%",
                      right: "0.75rem",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: theme.colors.secondary,
                      fontSize: "1rem",
                      lineHeight: 0,
                    }}
                    title={showPassword ? "Hide" : "Show"}
                  >
                    <i
                      className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                    ></i>
                  </span>
                </div>
              </div>
              

              {/* Error Message */}
              {error && (
                <div
                  className="text-center p-2 mb-3"
                  style={{
                    backgroundColor: `${theme.colors.error}15`,
                    color: theme.colors.error,
                    borderRadius: theme.borderRadius.small,
                    fontSize: "0.85rem",
                  }}
                >
                  {error}
                </div>
              )}

              {/* Submit Button */}
              <button
                type="submit"
                className="w-100 shadow-sm"
                disabled={loading}
                style={{
                  height: "42px",
                  backgroundColor: theme.colors.primary,
                  color: "#fff",
                  border: "none",
                  borderRadius: theme.borderRadius.medium,
                  fontSize: "0.95rem",
                  letterSpacing: "0.5px",
                  transition: "background-color 0.3s ease",
                  opacity: loading ? 0.7 : 1,
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.backgroundColor = "#3c4a24")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.backgroundColor = theme.colors.primary)
                }
              >
                {loading ? "Logging in..." : "Login"}{" "}
                {!loading && <i className="fas fa-forward ms-2"></i>}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
